const handleIncrement = (input) => {
  const maxValue = parseInt(input.getAttribute('max')) || Infinity

  if (input.value < maxValue) {
    input.value++
    updateButtonStates(input)
  }
}

const handleDecrement = (input) => {
  const minValue = parseInt(input.getAttribute('min')) || 0

  if (input.value > minValue) {
    input.value--
    updateButtonStates(input)
  }
}

const updateButtonStates = (input) => {
  const decrementBtn = input.parentNode.querySelector('[data-decrement]')
  const incrementBtn = input.parentNode.querySelector('[data-increment]')

  const minValue = parseInt(input.getAttribute('min')) || 0
  const maxValue = parseInt(input.getAttribute('max')) || Infinity

  if (decrementBtn) {
    decrementBtn.disabled = input.value <= minValue
  }
  if (incrementBtn) {
    incrementBtn.disabled = input.value >= maxValue
  }

  input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }))

  const parent = input.closest('.count-input')

  if (!parent.classList.contains('count-input-collapsible')) {
    return
  }

  const inputValue = incrementBtn.querySelector('[data-count-input-value]')

  if (input.value > 0) {
    parent.classList.remove('collapsed')
    if (inputValue) {
      inputValue.textContent = input.value
    }
  } else {
    parent.classList.add('collapsed')
    if (inputValue) {
      inputValue.textContent = ''
    }
  }
}

document.addEventListener('click', (event) => {
  const incrementBtn = event.target.closest('[data-increment]')
  const decrementBtn = event.target.closest('[data-decrement]')

  if (!incrementBtn && !decrementBtn) {
    return
  }

  const input = (incrementBtn || decrementBtn).parentNode.querySelector('.form-control')

  if (incrementBtn) {
    handleIncrement(input)
  } else {
    handleDecrement(input)
  }
})
